import {
  GridCountFunction,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import { simP1DocumentForGrid } from '../../../spd/components/SimP1Documents/SimP1DocumentsSearch';
import {
  DefaultApi,
  GetJudgmentP1DocumentDto,
} from '../autogenerated/spdApiClient';

export interface SimP1DocumentContextInterface {
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    onRetry?: () => void,
  ) => Promise<GridRecord[]>;
  getAllCount: GridCountFunction;
  getRejectedByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    onRetry?: () => void,
  ) => Promise<GridRecord[]>;
  getRejectedCount: GridCountFunction;
  getIncompleteByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    onRetry?: () => void,
  ) => Promise<GridRecord[]>;
  getIncompleteCount: GridCountFunction;
  getWaitingByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    onRetry?: () => void,
  ) => Promise<GridRecord[]>;
  getWaitingCount: GridCountFunction;
  getToSignByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
    onRetry?: () => void,
  ) => Promise<GridRecord[]>;
  getToSignCount: GridCountFunction;
  getLastForJudgment: (judgmentId: string) => Promise<GetJudgmentP1DocumentDto>;
  getAcceptedXmlForJudgment: (judgmentId: string) => Promise<string>;
  retry: (documentId: string) => Promise<void>;
  sign: (documentId: string) => Promise<void>;
  signWithSzafir: (
    documentId: string,
    signedXmlBase64: string,
  ) => Promise<void>;
}

export const JudgmentP1DocumentContext = (
  api: DefaultApi,
): SimP1DocumentContextInterface => ({
  getAllByPortion: async (
    pageSize,
    pageNumber,
    orderBy = '',
    orderDirection = '',
    filterText = '',
    filterColumns = '',
    onRetry?: () => void,
  ) => {
    const data = await api.judgmentP1DocumentControllerGetDocumentsAllByPage(
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    );
    return data.map(doc => simP1DocumentForGrid(doc, onRetry));
  },

  getAllCount: (filterText = '', filterColumns = '') =>
    api.judgmentP1DocumentControllerGetDocumentsAllCount(
      filterText,
      filterColumns,
    ),

  getRejectedByPortion: async (
    pageSize,
    pageNumber,
    orderBy = '',
    orderDirection = '',
    filterText = '',
    filterColumns = '',
    onRetry?: () => void,
  ) => {
    const data =
      await api.judgmentP1DocumentControllerGetDocumentsRejectedByPage(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      );
    return data.map(doc => simP1DocumentForGrid(doc, onRetry));
  },

  getRejectedCount: (filterText = '', filterColumns = '') =>
    api.judgmentP1DocumentControllerGetDocumentsRejectedCount(
      filterText,
      filterColumns,
    ),

  getIncompleteByPortion: async (
    pageSize,
    pageNumber,
    orderBy = '',
    orderDirection = '',
    filterText = '',
    filterColumns = '',
    onRetry?: () => void,
  ) => {
    const data =
      await api.judgmentP1DocumentControllerGetDocumentsIncompleteByPage(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      );
    return data.map(doc => simP1DocumentForGrid(doc, onRetry));
  },

  getIncompleteCount: (filterText = '', filterColumns = '') =>
    api.judgmentP1DocumentControllerGetDocumentsIncompleteCount(
      filterText,
      filterColumns,
    ),

  getToSignByPortion: async (
    pageSize,
    pageNumber,
    orderBy = '',
    orderDirection = '',
    filterText = '',
    filterColumns = '',
    onRetry?: () => void,
  ) => {
    const data = await api.judgmentP1DocumentControllerGetDocumentsToSignByPage(
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      filterColumns,
    );
    return data.map(doc => simP1DocumentForGrid(doc, onRetry));
  },

  getToSignCount: (filterText = '', filterColumns = '') =>
    api.judgmentP1DocumentControllerGetDocumentsToSignCount(
      filterText,
      filterColumns,
    ),

  getWaitingByPortion: async (
    pageSize,
    pageNumber,
    orderBy = '',
    orderDirection = '',
    filterText = '',
    filterColumns = '',
    onRetry?: () => void,
  ) => {
    const data =
      await api.judgmentP1DocumentControllerGetDocumentsWaitingByPage(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      );
    return data.map(doc => simP1DocumentForGrid(doc, onRetry));
  },

  getWaitingCount: (filterText = '', filterColumns = '') =>
    api.judgmentP1DocumentControllerGetDocumentsWaitingCount(
      filterText,
      filterColumns,
    ),

  getLastForJudgment: (judgmentId: string) =>
    api.judgmentP1DocumentControllerGetDocumentForJudgment(judgmentId),

  getAcceptedXmlForJudgment: (judgmentId: string) =>
    api.judgmentP1DocumentControllerGetAcceptedXmlForJudgment(judgmentId),

  retry: (documentId: string) =>
    api.judgmentP1DocumentControllerRetryDocument(documentId),

  sign: (documentId: string) =>
    api.judgmentP1DocumentControllerSignDocument(documentId),

  signWithSzafir: (documentId: string, signedXmlBase64: string) =>
    api.judgmentP1DocumentControllerSignDocumentWithSzafir(documentId, {
      signedXmlBase64,
    }),
});
